<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-我要作业-添加
    -->
  <el-dialog
    title="添加我要作业"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form
        size="small"
        :model="form"
        ref="form"
        :rules="rules"
        label-width="100px"
      >

        <!-- 类型选择 -->
        <el-form-item label="作业类型" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio label="car_to_land">车找地</el-radio>
            <el-radio label="land_to_car">地找车</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 车找地字段组 -->
        <template v-if="form.type === 'car_to_land'">
          <el-tabs v-model="selectMap" @tab-click="handleClick">
            <el-tab-pane label="地址" name="1">
              <div>
                <el-form-item label="地址" prop="address">
                  <el-input
                    v-model="form.address"
                    placeholder="请输入地址"
                    class="max-w460"
                  ></el-input>
                </el-form-item>
                <el-form-item label="坐标" prop="coordinate">
                  <el-row class="mb16">
                    <el-col :span="24">
                      <el-input
                        v-model="form.coordinate"
                        class="max-w460"
                      ></el-input>
                    </el-col>
                  </el-row>
                  <el-row class="mb16">
                    <el-col :span="24">
                      <Getpoint
                        v-if="selectMap == 1"
                        :form="form"
                        @getMapdata="getMapdataFunc"
                        @chose="choseFunc"
                      ></Getpoint>
                    </el-col>
                  </el-row>
                </el-form-item>
              </div>
            </el-tab-pane>
          </el-tabs>

             <el-form-item label="联系方式" prop="area"
            ><el-input
              v-model="form.phone"
              placeholder="请输入联系方式"
              class="max-w460"
            ></el-input
          ></el-form-item>

          <el-form-item label="面积" prop="area"
            ><el-input
              v-model="form.area"
              placeholder="请输入面积"
              class="max-w460"
            ></el-input
          ></el-form-item>

          <el-form-item label="采摘时间" prop="picking_time">
            <el-date-picker
              v-model="form.picking_time"
              type="month"
              placeholder="选择采摘时间"
              value-format="yyyy-MM"
              format="yyyy年MM月"
            >
            </el-date-picker>
          </el-form-item>

       <el-form-item label="车型" prop="model">
               <el-input
              v-model="form.vehicle_mode"
      

            ></el-input>
            <!-- <el-select
              v-model="form.vehicle_model_id"
              filterable
              placeholder="请选择车型"
              style="width: 100%"
              :loading="loadingVehicleModels"
            >
              <el-option
                v-for="vehicleModel in vehicleModelList"
                :key="vehicleModel.vehicle_model_id"
                :label="vehicleModel.name"
                :value="vehicleModel.vehicle_model_id"
              >
              </el-option>
            </el-select> -->
          </el-form-item>

          <el-form-item label="价格(元)" prop="price">
            <el-input-number
              v-model="form.price"
              :min="0"
              :precision="2"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
        </template>

        <!-- 地找车字段组 -->
        <template v-else-if="form.type === 'land_to_car'">

          
                 <el-form-item label="联系方式" prop="area"
            ><el-input
              v-model="form.phone"
              placeholder="请输入联系方式"
              class="max-w460"
            ></el-input
          ></el-form-item>
          <el-form-item label="车辆信息" prop="vehicle_info">
            <el-input
              v-model="form.vehicle_info"
              type="textarea"
              placeholder="请输入车辆详细信息（如载重、尺寸等）"
              :rows="4"
              class="max-w460"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="每日费用(元)" prop="daily_fee">
            <el-input-number
              v-model="form.daily_fee"
              :min="0"
              :precision="2"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
        </template>

        <el-form-item label="排序" prop="name"
          ><el-input
            v-model="form.sort"
            placeholder="请输入排序"
            class="max-w460"
          ></el-input
        ></el-form-item>

        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc"
            >取消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="onSubmit"
            :loading="loading"
            >提交</el-button
          >
        </div>
      </el-form>
      <!--商品图片组件-->
      <Upload
        v-if="isProductUpload"
        :config="{ total: 9 }"
        :isupload="isProductUpload"
        @returnImgs="returnProductImgsFunc"
        >上传图片
      </Upload>
      <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
    </div>
  </el-dialog>
</template>

<script>
import Job_needApi from "@/api/job_need.js";
import Vehicle_modelApi from "@/api/vehicle_model.js";
import Getpoint from "@/components/map/Getpoint.vue";
import Upload from "@/components/file/Upload";
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from "@/components/UE.vue";
export default {
  components: {
    /*图片上传*/
    Upload: Upload,
    Categoryas,
    draggable,
    Uediter,
    Getpoint
  },
  data() {
    return {
      selectMap: "1",
      vehicleModelList: [],
      loadingVehicleModels: false,

      /*是否上传图片*/
      isupload: false,
      isImg: false,
      /*富文本配置*/
      ueditor: {
        text: "",
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        vehicle_model_id: null,
        code: "custom",
        sort: 50,
        type: "car_to_land", // 默认类型
        // 车找地字段
        address: "",
        coordinate: "",
        longitude: "",
        latitude: "",
        area: null,
        picking_time: "",
        vehicle_model: "",
        price: null,
        // 地找车字段
        vehicle_info: "",
        daily_fee: null
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [
          // { required: true, message: "请输入我要作业名称", trigger: "blur" }
        ]
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    console.log(11111);
    this.dialogVisible = this.open_add;
    this.addVehicleModelList();
  },
  props: ["open_add"],
  methods: {
    addVehicleModelList() {
      var self = this;
      Vehicle_modelApi.listx({}, true)
        .then(data => {
          self.loading = false;
          self.vehicleModelList = data.data;
          // console.log("vehicleModelList", self.vehicleModelList);
        })
        .catch(error => {});
    },
    handleClick(tab, event) {
      console.log(tab, event);
      // this.selectMap = type;
    },
    /*获取经纬度*/
    getMapdataFunc(e) {
      console.log(e);
      this.form.coordinate = e.data[0].toFixed(6) + "," + e.data[1].toFixed(6);
    },

    /*选择的地址*/
    choseFunc(e) {
      this.form.coordinate = e.location.lat + "," + e.location.lng;
      this.form.address = e.address;
    },
    chooseCategory() {
      this.iscategorya = true;
    },
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, type: "" });
    },
    cancelFunc() {
      //取消
      this.dialogFormVisible("error");
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      // if(!form.categorya.categorya_id){
      //   self.$message({
      //           message:"请选择全分类",
      //           type: 'error'
      //         });
      //         return;
      // }
      // if (form.image.length <= 0) {
      //   self.$message({
      //     message: "请上传图片",
      //     type: "error"
      //   });
      //   return;
      // }
      // form.categorya = JSON.stringify(form.categorya );
      // form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Job_needApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: "success"
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false, type: "" });
    },
    /*打开上传图片*/
    openProductUpload: function(code) {
      this.isProductUpload = true;
      this.code = code;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (this.code == "album") {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
      } else {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }

      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index, code) {
      if (code == "album") {
        this.form.image.splice(index, 1);
      } else if (code == "bannar") {
        this.form.bannar.splice(index, 1);
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/job_need/index/part/add.vue